//import { unblock } from 'yett'

const params = app_rgpd_params || []
const lsRgpd = localStorage.getItem('rgpd')

if (lsRgpd && lsRgpd === 'accept')
{
	window.yett.unblock()
}
else if (!lsRgpd && YETT_BLACKLIST.length)
{
	rgpd()
}

function rgpd ()
{
	const div = document.createElement('div')
	div.id = 'rgpd'
	div.innerHTML = `
	<div class="inner">
		<p>
			Notre site internet utilise des cookies afin d'établir des statistiques sur nos visiteurs.
		</p>
		<p>
			En savoir plus sur <a href="${params.rgpd_url}">notre politique en matière de cookies</a>.
		</p>
		<div class="buttons">
			<a class="accept" href="#">Accepter</a>
			<a class="decline" href="#">Refuser</a>
		</div>
	</div>
	`
	document.body.append(div)
	
	div.querySelectorAll('.buttons a').forEach(el =>
	{
		el.addEventListener('click', () =>
		{
			if (el.className === 'accept')
			{
				localStorage.setItem('rgpd', 'accept')
				window.yett.unblock()
			}
			else
			{
				localStorage.setItem('rgpd', 'decline')
			}
			
			div.remove()
		})
	})
}

